import BaseModel from '../base/BaseModel.model';
export default class BudgetExpense extends BaseModel {

   public name?: string;
   public index?: number;
   
   constructor(){
       super();
       this.init();
   }

    init(){
       this.name = "";
       this.index = null;
    }

}